/** Titelbild, Einstellungen und der gemeinsame Rahmen der Menüseiten. */
import type { menu as en } from '../en/menu';
import type { Translated } from '../types';

export const menu: Translated<typeof en> = {
  'menu.kicker': 'Generalstab · Operationsabteilung',
  'menu.tagline1': 'Jeder Befehl braucht Zeit.',
  'menu.tagline2': 'Jede Meldung ist schon alt.',
  'menu.aria': 'Hauptmenü',
  'menu.sp.label': 'Einzelspieler',
  'menu.sp.desc': 'Kommando gegen die Maschine. Anhalten, wann immer es sein muss.',
  'menu.scenarios.label': 'Szenarien',
  'menu.scenarios.desc': 'Fünf Lagen nach historischem Vorbild, auf neuem Gelände ausgefochten.',
  'menu.academy.label': 'Kriegsakademie',
  'menu.academy.desc': 'Die Generalstabsschule: kurze Lehrstunden an einer ruhigen Front.',
  'menu.mp.label': 'Mehrspieler',
  'menu.mp.desc': 'Bis zu sechs Generäle. Räume per Kennung aus fünf Buchstaben.',
  'menu.archive.label': 'Filmarchiv',
  'menu.archive.desc': 'Kriege auf Zelluloid: einen gesicherten Film laden und noch einmal sehen.',
  'menu.manual.label': 'Felddienstordnung',
  'menu.manual.desc': 'Kuriere, Nebel, der Kessel — wie hier Krieg geführt wird.',
  'menu.settings.label': 'Einstellungen',
  'menu.settings.desc': 'Ton, Skalierung, Sprache, Truppenzeichen und Kartentisch.',
  'menu.net.label': 'FERNMELDENETZ',
  'menu.net.online': 'VERBUNDEN',
  'menu.net.connecting': 'VERBINDUNG WIRD HERGESTELLT',
  'menu.net.offline': 'IN BEREITSCHAFT',
  'menu.build': 'STABSTERMINAL M.24 · STAND 0.1',
  'menu.quote.stamp': 'Vom Kriege',
  'menu.quote.text': '„Es ist im Kriege alles sehr einfach, aber das Einfachste ist schwierig.“',
  'menu.quote.by': 'Carl von Clausewitz, 1832',
  'menu.offer.head': 'TELEGRAMM · KRIEGSAKADEMIE',
  'menu.offer.urgent': 'DRINGEND',
  'menu.offer.title': 'Neu im Stab?',
  'menu.offer.text':
    'Vor dem ersten Kommando die Kriegsakademie besuchen STOP Kuriere, Nebel und Kessel in einer Viertelstunde STOP',
  'menu.offer.enrol': 'Einschreiben',
  'menu.offer.notNow': 'Später',
  'menu.offer.stamp': 'Einladung',
  'menu.lang.aria': 'Sprache der Oberfläche',

  'frame.logo': 'FRICTION',

  'settings.kicker': 'Stabsterminal',
  'settings.title': 'Einstellungen',
  'settings.language': 'Sprache',
  'settings.language.label': 'Sprache der Oberfläche',
  'settings.language.hint': 'Menüs, Berichte, Fernschreiber und Kriegsakademie. Wirkt sofort.',
  'settings.sound': 'Ton',
  'settings.master': 'Gesamtlautstärke · {value}',
  'settings.muted': 'stumm',
  'settings.master.hint': 'Der Ton setzt nach dem ersten Klick ein — früher erlauben es die Browser nicht.',
  'settings.master.aria': 'Gesamtlautstärke',
  'settings.ambience': 'Umgebung · {value}',
  'settings.ambience.hint':
    'Raumklang und Wind, fernes Geschützfeuer der Gefechte im Blick, die Morgenglocke.',
  'settings.ambience.aria': 'Lautstärke der Umgebung',
  'settings.effects': 'Effekte · {value}',
  'settings.effects.hint':
    'Fernschreiber, Stempel und der Fernmeldeverkehr: Morsen, Feldfernsprecher, Funkrauschen.',
  'settings.effects.aria': 'Lautstärke der Effekte',
  'settings.mute': 'Ton ganz aus',
  'settings.mute.hint': 'Schaltet alles stumm; die Tonerzeugung ruht.',
  'settings.display': 'Darstellung',
  'settings.scale': 'Skalierung der Oberfläche · {value}',
  'settings.scale.hint': 'Zusätzlich zur automatischen Anpassung an die Bildschirmgröße.',
  'settings.scale.aria': 'Skalierung der Oberfläche',
  'settings.motion': 'Weniger Bewegung',
  'settings.motion.hint':
    'Keine Gleit-, Stempel- und Schreibmaschinen-Animationen; die Umgebung bleibt ruhig, die Geschütze leise.',
  'settings.newspaper': 'Morgenzeitung',
  'settings.newspaper.hint':
    'Täglich um 6 Uhr berichtet die Landeszeitung, was seit der letzten Ausgabe geschah.',
  'settings.mapTable': 'Kartentisch',
  'settings.edge': 'Randscrollen',
  'settings.edge.hint': 'Die Karte verschieben, wenn der Mauszeiger den Fensterrand berührt.',
  'settings.grid': 'Feldraster',
  'settings.grid.hint': 'Das Sechseckraster über die Karte legen.',
  'settings.counters': 'Truppenzeichen',
  'settings.counters.hint': 'Wie die Verbände auf der Karte und in allen Meldungen erscheinen. Wirkt sofort.',
  'settings.counters.illustrated': 'Bildzeichen',
  'settings.counters.illustrated.desc': 'Schützen, Lastwagen, Panzer, Geschütze und Reiter auf Pappmarken.',
  'settings.counters.nato': 'Taktische Zeichen',
  'settings.counters.nato.desc':
    'Die Zeichen des Generalstabs nach NATO: Kreuz für Infanterie, Oval für Panzer, Punkt für Geschütze.',
  'settings.restore': 'Standard wiederherstellen',
};
